<template>
  <div>
    <div class="dm1">
      <div>
        <span class="dm1_title">{{ $t('collectionCenter.deliveryMonitor') }}</span><br>
        <span class="dm1_msg">{{ $t('collectionCenter.deliveryFailureStats') }}</span>
      </div>
      <span class="dm1_time">{{ updateTime ? `${$t('customerManagements.dataUpdateTime')}：${updateTime}` : '' }}</span>
    </div>
    <el-card>
      <el-form :model="queryForm" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.latestFailTime')">
              <el-date-picker
                v-model="timeValue"
                type="datetimerange"
                range-separator="-"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                :end-placeholder="$t('collectionCenter.EndTime')"
                :start-placeholder="$t('collectionCenter.StartTime')"
                :clearable="false"
                style="width: 100%"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-select
                v-model="selectNum" :placeholder="$t('collectionCenter.pleaseChoose')"
                class="border_none" @change="changeNum"
              >
                <el-option :label="$t('newOrder.waybillNumber')" :value="1" />
                <el-option :label="$t('collectionCenter.ScanNumber')" :value="2" />
              </el-select>
              <el-input
                v-model="orderNumber"
                :placeholder="$t('collectionCenter.max2000Line')"
                clearable type="textarea" :rows="1"
                style="width: 100%"
                @blur="BlockNewNumber"
                @keydown.enter.native="BlockNewNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('placeOrder.client')">
              <el-select
                v-model="queryForm.params.customerIdList"
                :placeholder="$t('collectionCenter.tudo')"
                :remote-method="getCustomerPage"
                clearable filterable
                multiple collapse-tags
                remote reserve-keyword
                style="width: 100%"
                @change="changeCustomer"
                @clear="getCustomerPage('')"
                @focus="getCustomerPage('', true)"
              >
                <el-option
                  v-for="item in customerIdData"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.CommercialOwner')">
              <el-select
                v-model="queryForm.params.merchantCodeList"
                :placeholder="$t('collectionCenter.tudo')"
                :remote-method="remoteMethod"
                clearable filterable
                multiple collapse-tags
                remote reserve-keyword
                style="width: 100%"
                @clear="remoteMethod('')"
              >
                <el-option
                  v-for="item in merchantData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-top: 32px">
            <el-button size="medium" type="primary" @click="searchForm">{{ $t('collectionCenter.search') }}</el-button>
            <el-button size="medium" @click="resetSearch">{{ $t('collectionCenter.reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row class="package_box">
      <el-col :span="6">
        <el-card>
          <div style="font-size: 14px; color: #6b7280">{{ $t('collectionCenter.failedDeliveryCount') }}</div>
          <div style="font-size: 25px; font-weight: 700;color: #111827">{{ packageList.totalCount }}</div>
          <div style="font-size: 12px; color: #9ca3af">{{ $t('collectionCenter.totalPackagesFiltered') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div style="font-size: 14px; color: #6b7280">{{ $t('collectionCenter.multiFailPackages') }}</div>
          <div style="font-size: 25px; font-weight: 700;color: #111827">{{ packageList.twoFailureCount }}</div>
          <div style="font-size: 12px; color: #9ca3af">{{ $t('collectionCenter.failCountGe2') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div style="font-size: 14px; color: #6b7280">{{ $t('collectionCenter.multiFailPackages3Plus') }}</div>
          <div style="font-size: 25px; font-weight: 700;color: #111827">{{ packageList.threeFailureCount }}</div>
          <div style="font-size: 12px; color: #9ca3af">{{ $t('collectionCenter.qualityControlFocus') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div style="font-size: 14px; color: #6b7280">{{ $t('collectionCenter.avgRetryInterval') }}</div>
          <div style="font-size: 25px; font-weight: 700;color: #111827">{{ packageList.averageInterval }}</div>
          <div style="font-size: 12px; color: #9ca3af">{{ $t('collectionCenter.adjacentFailInterval') }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card>
      <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
        <span style="font-size: 16px; font-weight: 600;color: #111827">{{ $t('collectionCenter.deliveryFailDetails') }}</span>
        <span>
          <el-button size="medium" @click="batchExportOpen">{{ $t('placeOrder.BatchExport') }}</el-button>
          <el-button size="medium" type="primary" @click="exportAll">{{ $t('collectionCenter.export') }}</el-button>
        </span>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
        max-height="500"
      >
        <el-table-column
          v-for="item in tableHeaderList" :key="item.prop"
          :prop="item.prop" :label="item.label" :width="item.cloWidth"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="item.prop === 'waybillNumber'"
              style="font-weight: bold;color: #2563eb"
            >
              {{ scope.row[item.prop] }}
            </div>
            <!--            <div v-else-if="item.prop === 'waybillStatusDesc'">-->
            <!--              <span v-if="scope.row.waybillStatus === 9" class="status_box status_blue">{{ scope.row.waybillStatusDesc }}</span>-->
            <!--              <span v-else-if="scope.row.waybillStatus === 2" class="status_box status_loading">{{ scope.row.waybillStatusDesc }}</span>-->
            <!--              <span v-else-if="scope.row.waybillStatus === 3" class="status_box status_red">{{ scope.row.waybillStatusDesc }}</span>-->
            <!--              <span v-else>&#45;&#45;</span>-->
            <!--            </div>-->
            <div v-else-if="item.prop === 'secondTimeIntervalStr' || item.prop === 'firstTimeIntervalStr'">
              <span v-if="scope.row[item.prop]" style="color: #7c3aed;font-weight: bold">{{ scope.row[item.prop] }}</span>
              <span v-else>--</span>
            </div>
            <div v-else>{{ scope.row[item.prop] || '--' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getTableData"
          @size-change="getTableData(1)"
        />
      </div>
    </el-card>

    <!--批量单号导出-->
    <el-dialog
      :visible.sync="openShow"
      :title="$t('placeOrder.BatchExport')"
      :close-on-click-modal="false"
      :close-on-click-outside="false"
      width="500px"
      @close="closeBatchExport"
    >
      <div style="padding: 20px" class="batchExport_box">
        <el-form ref="batchExportRef" :model="beForm" label-width="100px">
          <el-form-item
            :rules="[{ required: true, message: $t('collectionCenter.notNull') }]"
            prop="orderNumber"
          >
            <el-select v-model="beForm.exportType" @change="changeExportType">
              <el-option :label="$t('collectionCenter.waybillNumber')" :value="1" />
              <el-option :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
            </el-select>
            <br>
            <el-input
              v-model="beForm.orderNumber"
              :placeholder="$t('collectionCenter.max2000Line')"
              clearable type="textarea" :rows="5"
              style="width: 100%; margin-top: 5px"
              @blur="BlockNewBatchExport"
              @keydown.enter.native="BlockNewBatchExport"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="closeBatchExport">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button type="primary" @click="BatchExport">{{ $t('collectionCenter.CheckItOutNow') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import {
  queryAllMerchantCode
} from '@/api/lanshou';
import { apiCustomerPage } from '@/api/customer';
import { attemptDeliveryPage, attemptDeliverySts, attemptDeliveryExport } from '@/api/logisticsOrders';
import { goRWExportList } from '@/utils/goExportList';

export default {
  name: 'DeliveryAttemptMonitor',
  data() {
    return {
      updateTime: '', // 年-月-日 时:分
      beForm: {
        exportType: 1,
        orderNumber: ''
      },
      openShow: false,
      batchExportForm: {
        waybillNumberList: [],
        scanOrderNumberList: []
      },
      merchantData: [],
      selectedMerchantData: [], // 缓存已选中的商家数据，用于远程搜索时拼接
      customerIdData: [],
      selectNum: 1,
      orderNumber: '',
      timeValue: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 20,
        params: {
          latestFailureStartTime: '',
          latestFailureEndTime: '',
          customerIdList: [],
          merchantCodeList: [],
          waybillNumberList: [],
          scanOrderNumberList: []
        }
      },
      packageList: {},
      tableData: [],
      total: 0,
      tableHeaderList: [
        { label: this.$t('collectionCenter.waybillNumber'), prop: 'waybillNumber', cloWidth: '200' },
        { label: this.$t('placeOrder.client'), prop: 'customerName', cloWidth: '150' },
        { label: this.$t('collectionCenter.CommercialOwner'), prop: 'merchantName', cloWidth: '140' },
        { label: this.$t('newOrder.waybillStatus'), prop: 'waybillStatusDesc', cloWidth: '100' },
        { label: this.$t('collectionCenter.deliveryFailCount'), prop: 'failureCount', cloWidth: '120' },
        { label: this.$t('collectionCenter.latestFailTime'), prop: 'latestFailureTime', cloWidth: '160' },
        { label: this.$t('collectionCenter.latestFailReason'), prop: 'latestFailureReason', cloWidth: '140' },
        { label: this.$t('collectionCenter.firstFailTime'), prop: 'firstFailureTime', cloWidth: '160' },
        { label: this.$t('orderCenterCont.DeliveryFailureReasons'), prop: 'firstFailureReason', cloWidth: '140' },
        { label: this.$t('collectionCenter.secondFailTime'), prop: 'secondFailureTime', cloWidth: '160' },
        { label: this.$t('orderCenterCont.DeliveryFailureReasons'), prop: 'secondFailureReason', cloWidth: '140' },
        { label: this.$t('collectionCenter.timeInterval'), prop: 'firstTimeIntervalStr', cloWidth: '140' },
        { label: this.$t('collectionCenter.thirdFailTime'), prop: 'thirdFailureTime', cloWidth: '160' },
        { label: this.$t('orderCenterCont.DeliveryFailureReasons'), prop: 'thirdFailureReason', cloWidth: '140' },
        { label: this.$t('collectionCenter.timeInterval'), prop: 'secondTimeIntervalStr', cloWidth: '140' }
      ]
    };
  },
  watch: {
    'queryForm.params.merchantCodeList': {
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          this.selectedMerchantData = [];
          return;
        }
        // 将当前 merchantData 中新选中的项缓存到 selectedMerchantData
        newVal.forEach(id => {
          if (!this.selectedMerchantData.find(item => item.value === id)) {
            const found = this.merchantData.find(item => item.value === id);
            if (found) {
              this.selectedMerchantData.push({ ...found });
            }
          }
        });
        // 移除已取消选中的项
        this.selectedMerchantData = this.selectedMerchantData.filter(
          item => newVal.includes(item.value)
        );
      },
      deep: true
    }
  },
  created() {
    this.defaultTime();
    this.getTableData('');
    this.getViewData();
    this.remoteMethod('');
  },
  methods: {
    changeExportType() {
      this.$nextTick(() => {
        this.$refs.batchExportRef.clearValidate();
      });
    },
    defaultTime() {
      const today = dayjs().format('YYYY-MM-DD');
      const threeDayAgo = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [threeDayAgo + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params.latestFailureStartTime = threeDayAgo + ' 00:00:00';
      this.queryForm.params.latestFailureEndTime = today + ' 23:59:59';
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.latestFailureStartTime = '';
        this.queryForm.params.latestFailureEndTime = '';
        return;
      }
      this.queryForm.params.latestFailureStartTime = val[0];
      this.queryForm.params.latestFailureEndTime = val[1];
    },
    searchForm() {
      this.getTableData(1);
      this.getViewData();
    },
    getTableData(val) {
      if (!this.timeValue || this.timeValue.length < 2) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      if (val === 1) {
        this.queryForm.pageNumber = 1;
      }
      const queryForm = this.formFn();
      attemptDeliveryPage(queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 统计数据
    getViewData() {
      const queryForm = this.formFn();
      attemptDeliverySts(queryForm.params).then(res => {
        if (res.code === 200) {
          this.packageList = res.data;
          this.updateTime = res.data.latestUpdateTime;
        }
      });
    },
    resetSearch() {
      this.queryForm.params = {
        latestFailureStartTime: '',
        latestFailureEndTime: '',
        customerIdList: [],
        merchantCodeList: [],
        waybillNumberList: [],
        scanOrderNumberList: []
      };
      this.selectNum = 1;
      this.orderNumber = '';
      this.defaultTime();
      this.getTableData('');
      this.getViewData();
      this.getCustomerPage('');
    },
    // 单号
    changeNum() {
      // 清空单号
      this.orderNumber = '';
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanOrderNumberList = [];
    },
    BlockNewNumber() {
      if (this.orderNumber) {
        let lines = this.orderNumber
          .split('\n')
          .filter(line => line && line.trim())
          .map(line => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.orderNumber = lines.join('\n');
        if (this.selectNum === 1) {
          // 运单号
          this.queryForm.params.waybillNumberList = lines;
        }
        if (this.selectNum === 2) {
          // 扫描单号
          this.queryForm.params.scanOrderNumberList = lines;
        }
      } else {
        this.queryForm.params.waybillNumberList = [];
        this.queryForm.params.scanOrderNumberList = [];
      }
    },
    // 客户
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerIdData.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerIdData = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerIdData = res.data.records;
          }
        });
      }
    },
    changeCustomer() {
      this.queryForm.params.merchantCodeList = [];
      if (this.queryForm.params.customerIdList.length <= 0) {
        this.getCustomerPage('');
      }
      this.remoteMethod('');
    },
    remoteMethod(value) {
      const merchantForm = {
        customerId: '',
        merchantCode: '',
        customerIdList: this.queryForm.params.customerIdList,
        merchantName: value
      };
      queryAllMerchantCode(merchantForm).then(res => {
        if (res.code === 200) {
          this.merchantData = (res.data.records || []).map((item) => {
            return {
              value: item.id,
              label: item.merchantName + ' / ' + item.merchantCode,
              merchantCode: item.merchantCode
            };
          });
          // 将已选中的数据拼接在查询到的数据后边
          const selectedIds = this.queryForm.params.merchantCodeList || [];
          const existingIds = new Set(this.merchantData.map(item => item.value));
          const missingSelected = this.selectedMerchantData.filter(
            item => selectedIds.includes(item.value) && !existingIds.has(item.value)
          );
          if (missingSelected.length > 0) {
            this.merchantData = [...this.merchantData, ...missingSelected];
          }
        }
      });
    },
    exportAll() {
      if (!this.timeValue || this.timeValue.length < 2) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('operationCenter.noDataExported')); // 列表暂无数据，无法导出
        return;
      }
      const queryForm = this.formFn();
      attemptDeliveryExport(queryForm.params).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    formFn() {
      const formParams = JSON.parse(JSON.stringify(this.queryForm));
      if (formParams.params.merchantCodeList && formParams.params.merchantCodeList.length > 0) {
        formParams.params.merchantCodeList = [...new Set(
          formParams.params.merchantCodeList.map(selectedId => {
            const found = this.merchantData.find(m => m.value === selectedId);
            return found ? found.merchantCode : selectedId;
          })
        )];
      }
      return formParams;
    },
    batchExportOpen() {
      this.openShow = true;
      this.$refs.batchExportRef.clearValidate();
    },
    closeBatchExport() {
      this.beForm = {
        exportType: 1,
        orderNumber: ''
      };
      this.batchExportForm.waybillNumberList = [];
      this.batchExportForm.scanOrderNumberList = [];
      this.$refs.batchExportRef.clearValidate();
      this.openShow = false;
    },
    BlockNewBatchExport() {
      if (this.beForm.orderNumber) {
        let lines = this.beForm.orderNumber
          .split('\n')
          .filter(line => line && line.trim())
          .map(line => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.beForm.orderNumber = lines.join('\n');
        if (this.beForm.exportType === 1) {
          // 运单号
          this.batchExportForm.waybillNumberList = lines;
        }
        if (this.beForm.exportType === 2) {
          // 扫描单号
          this.batchExportForm.scanOrderNumberList = lines;
        }
      } else {
        this.batchExportForm.waybillNumberList = [];
        this.batchExportForm.scanOrderNumberList = [];
      }
    },
    BatchExport() {
      this.$refs.batchExportRef.validate(valid => {
        if (valid) {
          attemptDeliveryExport(this.batchExportForm).then(res => {
            if (res.code === 200) {
              this.closeBatchExport();
              goRWExportList(this);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dm1 { display: flex;justify-content: space-between;align-items: flex-start;margin-bottom: 15px; }
.dm1_title { font-size: 20px; color: #111827; font-weight: 700 }
.dm1_msg { font-size: 13px; color: #6b7280; }
.dm1_time {display: inline-block; background: #fff; padding: 8px 12px; border: 1px solid #e9ebee; border-radius: 10px;font-size: 14px;color: #6b7280;}

.border_none ::v-deep .el-input__inner {border: none !important;}

.status_box {display: inline-block;padding: 2px 8px;border-radius: 10px;font-size: 12px;}
.status_blue { background: #eff6ff; color: #1d4ed8; }
.status_loading { background: #fff7ed; color: #c2410c; }
.status_red { background: #fef2f2; color: #dc2626; }

.package_box { display: flex; justify-content: space-between; gap: 20px;margin: 20px -20px}

.batchExport_box ::v-deep .el-form-item__content {width: 100%; margin-left: 0 !important;}
</style>
